// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../styles/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__row___oLbkE {
  background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayLight"]};
  border: 1px solid transparent;
  border-radius: 5px;
  display: flex;
  flex-basis: auto;
  flex-direction: column;
  flex-grow: 0;
  justify-content: space-between;
  margin-bottom: 5px;
  padding: 8px;
  width: 32.666%;
}

@media (max-width: 1024px) {
  .styles__row___oLbkE {
    width: 49%;
  }
}

@media (max-width: 500px) {
  .styles__row___oLbkE {
    width: 98%;
  }
}

.styles__rowError___bTI1d {
}

.styles__rowError___bTI1d .styles__value___xRZ4K,
  .styles__rowError___bTI1d .styles__label___rgRPF {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]};
  }

.styles__rowError___bTI1d .styles__error___fxsk9 {
    font-weight: bold;
  }

.styles__label___rgRPF {
  align-items: center;
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["text"]};
  display: flex;
  flex-flow: row wrap;
  font-size: 11px;
  font-weight: bold;
  justify-content: space-between;
  margin-bottom: 3px;
}

.styles__error___fxsk9 {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]};
}

.styles__value___xRZ4K {
  font-weight: lighter;
  word-break: break-all;
}

.styles__valueMono___HZQW1 {
  font-family: MaisonMono, monospace;
}

.styles__valueBlank___ppDl1 {
}

.styles__match___O9LJI {
  background-color: #EFF8EC;
  border: 1px solid #7FCA22;
}

.styles__noMatch___gXWol {
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRedLight"]};
  border-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]};
}

.styles__copy___U3xpn {
  align-items: center;
  color: darkgray;
  display: flex;
  flex-direction: row;
  flex-shrink: 0;
  font-size: 11px;
  font-style: italic;
}

.styles__copy___U3xpn span {
    margin-right: 5px;
  }

.styles__copy___U3xpn button {
    background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]};
    border-radius: 5px;
    color: white;
    height: 25px;
    padding: 0;
    width: 25px;
  }

.styles__copy___U3xpn button:hover {
    background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueDark"]};
  }
`, "",{"version":3,"sources":["webpack://./universal/components/References/MergeContactFormRef/MergeContactField/styles.css"],"names":[],"mappings":"AAGA;EACE,wDAAuB;EACvB,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,YAAY;EACZ,8BAA8B;EAC9B,kBAAkB;EAClB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;AAWA;;AARE;;IAEE,mDAAY;EACd;;AAEA;IACE,iBAAiB;EACnB;;AAGF;EACE,mBAAmB;EACnB,mDAAW;EACX,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,mDAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EAEE,kCAAkC;AACpC;;AAEA;AAEA;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,8DAA4B;EAC5B,0DAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,kBAAkB;AAkBpB;;AAhBE;IACE,iBAAiB;EACnB;;AAEA;IACE,8DAAwB;IACxB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,UAAU;IACV,WAAW;EACb;;AAEA;IACE,8DAA4B;EAC9B","sourcesContent":["@value colors: \"styles/colors.css\";\n@value gtGreen, gtRed, gtRedLight, gtBlue, gtBlueDark, gtGrayLight, text from colors;\n\n.row {\n  background: gtGrayLight;\n  border: 1px solid transparent;\n  border-radius: 5px;\n  display: flex;\n  flex-basis: auto;\n  flex-direction: column;\n  flex-grow: 0;\n  justify-content: space-between;\n  margin-bottom: 5px;\n  padding: 8px;\n  width: 32.666%;\n}\n\n@media (max-width: 1024px) {\n  .row {\n    width: 49%;\n  }\n}\n\n@media (max-width: 500px) {\n  .row {\n    width: 98%;\n  }\n}\n\n.rowError {\n  composes: row;\n\n  .value,\n  .label {\n    color: gtRed;\n  }\n\n  .error {\n    font-weight: bold;\n  }\n}\n\n.label {\n  align-items: center;\n  color: text;\n  display: flex;\n  flex-flow: row wrap;\n  font-size: 11px;\n  font-weight: bold;\n  justify-content: space-between;\n  margin-bottom: 3px;\n}\n\n.error {\n  color: gtRed;\n}\n\n.value {\n  font-weight: lighter;\n  word-break: break-all;\n}\n\n.valueMono {\n  composes: value;\n  font-family: MaisonMono, monospace;\n}\n\n.valueBlank {\n  composes: value;\n}\n\n.match {\n  background-color: #EFF8EC;\n  border: 1px solid #7FCA22;\n}\n\n.noMatch {\n  background-color: gtRedLight;\n  border-color: gtRed;\n}\n\n.copy {\n  align-items: center;\n  color: darkgray;\n  display: flex;\n  flex-direction: row;\n  flex-shrink: 0;\n  font-size: 11px;\n  font-style: italic;\n\n  span {\n    margin-right: 5px;\n  }\n\n  button {\n    background-color: gtBlue;\n    border-radius: 5px;\n    color: white;\n    height: 25px;\n    padding: 0;\n    width: 25px;\n  }\n\n  button:hover {\n    background-color: gtBlueDark;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors": `"styles/colors.css"`,
	"gtGreen": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]}`,
	"gtRed": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]}`,
	"gtRedLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRedLight"]}`,
	"gtBlue": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]}`,
	"gtBlueDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueDark"]}`,
	"gtGrayLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayLight"]}`,
	"text": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["text"]}`,
	"row": `styles__row___oLbkE`,
	"rowError": `styles__rowError___bTI1d styles__row___oLbkE`,
	"value": `styles__value___xRZ4K`,
	"label": `styles__label___rgRPF`,
	"error": `styles__error___fxsk9`,
	"valueMono": `styles__valueMono___HZQW1 styles__value___xRZ4K`,
	"valueBlank": `styles__valueBlank___ppDl1 styles__value___xRZ4K`,
	"match": `styles__match___O9LJI`,
	"noMatch": `styles__noMatch___gXWol`,
	"copy": `styles__copy___U3xpn`
};
export default ___CSS_LOADER_EXPORT___;
